import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Layout, ConfigProvider } from 'antd';
import ruRU from 'antd/es/locale/ru_RU';
import Logo from '../../images/logo.svg';
import MainMenu from '../../components/MainMenu/index';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import UserLogOut from '../../components/MainMenu/UserLogOut';
const { Header, Content } = Layout;

const Template = styled(Layout)`
  min-height: 100vh;
`;

const ContainerChat = styled(Content)`
  padding: 0px;
  margin: 0;
  height: calc(100vh - 100px);
`;

const Container = styled(Content)`
  padding: 30px 60px;
  margin: 0;
`;

const LogoBlock = styled.div`
  width: 135px;
  > svg {
    width: 100%;
    height: 100%;
  }
`;

function DefaultLayout({ children }) {
  const LogIn = useSelector((state) => get(state, 'user.access_token', false));
  return (
    <ConfigProvider locale={ruRU}>
      <Template>
        <Header className="flex items-center justify-between flex-row">
          <LogoBlock>
            <img src={Logo} />
          </LogoBlock>
          {LogIn && (
            <>
              <MainMenu />
              <UserLogOut />
            </>
          )}
        </Header>
        <Layout className="relative">
          {window.location.href.indexOf('chat') > 1 ? (
            <ContainerChat>{children}</ContainerChat>
          ) : (
            <Container
              className={
                !localStorage.getItem('access_token')
                  ? 'flex items-center justify-center'
                  : null
              }
            >
              {children}
            </Container>
          )}
        </Layout>
      </Template>
    </ConfigProvider>
  );
}

DefaultLayout.propTypes = {};

export default DefaultLayout;
